var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      class:
        !_vm.prevSelected && _vm.example.remain_num === 0
          ? "NCACroa_radio_off"
          : null
    },
    [
      _c("input", {
        ref: "radio",
        staticClass: "amw-global-radio",
        attrs: {
          type: "radio",
          name: "activity-radio-" + _vm.unique,
          disabled: !_vm.prevSelected && _vm.example.remain_num === 0
        },
        domProps: { value: _vm.example.se_code, checked: _vm.checked },
        on: { change: _vm.selectActivity }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "amw-radio-overlay" }),
      _vm._v(" "),
      _c("span", { staticClass: "amw-label-radio-text" }, [
        _vm._v("\n    " + _vm._s(_vm.display_text) + "\n    "),
        _vm.example.remain_num !== null
          ? _c("em", [_vm._v("(잔여 " + _vm._s(_vm.example.remain_num) + ")")])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-791e5542", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-791e5542","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/survey/components/SurveyExample.vue
// module id = null
// module chunks = 